const getLinks = (baseUrl, classbookUrl) => {
  const MAIN_LINKS = [
    { url: `${baseUrl}myeducation`, text: "Мои занятия" },
    { url: `${baseUrl}me`, text: "Кабинет ученика" },
    { url: `${baseUrl}progress`, text: "Успеваемость" },
    { url: `${baseUrl}favorites`, text: "Избранное" },
    { url: classbookUrl, text: "Учебник" },
    // { url: "https://about.lc.rt.ru/parents", text: "Родителям" },
    { url: `${baseUrl}profile`, text: "Мой профиль" },
  ];

  const SUB_LINKS = [
    { url: `${baseUrl}myeducation?tab=education`, text: "Школьные предметы" },
    { url: `${baseUrl}myeducation?tab=advancing`, text: "Развивающие курсы" },
    { url: `${baseUrl}myeducation?tab=english`, text: "Изучение английского" },
    { url: `${baseUrl}products`, text: "Дополнительное обучение" },
    { url: `${baseUrl}cart`, text: "Корзина" },
  ];

  const BOTTOM_LINKS = [
    { url: "https://about.lc.rt.ru/", text: "О Нас" },
    { url: "http://blog.lc.rt.ru", text: "Блог" },
    { url: "https://www.rt.ru/lc/teachers", text: "Преподаватели" },
    { url: "https://www.rt.ru/lc/partners", text: "Партнеры" },
  ];

  return { MAIN_LINKS, SUB_LINKS, BOTTOM_LINKS };
};

export default getLinks;



// WEBPACK FOOTER //
// ./app/frontend/components/getLinks.js